import React from 'react';

import {
  CircularProgress as UICircularProgress,
  LegacyBox,
  styled,
} from '@gogame/components';

const Container = styled(LegacyBox)`
  position: relative;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
`;

const ErrorIndicator = styled('div')`
  position: absolute;
  background: ${({ theme }) => theme.palette.error.main};
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  border-radius: 50%;
`;

const SubstrateCircularProgress = styled(UICircularProgress)`
  color: ${({ theme }) => theme.palette.action.selected};
  position: absolute;
  left: 0;
  top: 0;
`;

const CircularProgress = ({
  color,
  progress,
  size = 30,
  errorIndicatorSize = 12,
  error,
}) => (
  <Container size={size}>
    {error ? <ErrorIndicator size={errorIndicatorSize} /> : null}
    <SubstrateCircularProgress
      variant={'determinate'}
      value={100}
      thickness={6}
      size={size}
    />
    <UICircularProgress
      variant={'determinate'}
      value={progress}
      thickness={6}
      size={size}
      style={{ color }}
    />
  </Container>
);

export default CircularProgress;
